<template>
  <BreadCrumb PageTitle="Tables" />
  <TablesContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../template-components/Common/BreadCrumb.vue";
import TablesContent from "../template-components/Tables/TablesContent.vue";

export default defineComponent({
  name: "TablesPage",
  components: {
    BreadCrumb,
    TablesContent,
  },
});
</script>